/**
 * เปิดไฟล์ที่ต้อง "รอสร้างก่อน" (PDF สลิป/หนังสือรับรอง/สัญญา) โดยไม่โดนบล็อกป๊อปอัป
 *
 * เดิมทุกหน้าเขียน `const r = await api(); window.open(r.pdf_url)` — เบราว์เซอร์ถือว่า
 * window.open หลัง await ไม่ได้มาจากการกดของผู้ใช้ → บล็อกเงียบ ๆ
 * อาการจริง (สุกรี 18 ก.ย. 2569): กดออกหนังสือรับรอง หลังบ้านสร้าง PDF สำเร็จ
 * (audit CERTIFICATE_ISSUED) แต่ผู้ใช้ไม่เห็นอะไรเลย = "กดดูไม่ได้"
 *
 * วิธี: เปิดแท็บเปล่าทันทีในจังหวะคลิก → ไฟล์พร้อมค่อยใส่ URL
 * เปิดแท็บไม่ได้ (โดนบล็อก / แอป LINE) → เปิดไฟล์ในหน้าเดิมแทน ไม่ปล่อยเงียบ
 * ⚠️ ต้องเรียกตรงจาก onClick ก่อน await ตัวแรก ไม่งั้นแท็บเปล่าก็โดนบล็อกเหมือนเดิม
 */
export async function openWhenReady(getUrl: () => Promise<string>): Promise<string> {
  let tab: Window | null = null;
  try {
    tab = window.open('', '_blank');
  } catch {
    tab = null;
  }
  if (tab) {
    try {
      tab.document.title = 'กำลังสร้างไฟล์…';
      tab.document.body.innerHTML =
        '<p style="font-family:sans-serif;padding:24px;color:#555">กำลังสร้างไฟล์ กรุณารอสักครู่…</p>';
    } catch {
      /* บางเบราว์เซอร์ไม่ให้เขียนแท็บเปล่า — ไม่เป็นไร */
    }
  }
  try {
    const url = await getUrl();
    if (tab && !tab.closed) {
      tab.location.href = url;
    } else {
      window.location.href = url;
    }
    return url;
  } catch (e) {
    if (tab && !tab.closed) tab.close();
    throw e;
  }
}
